<template>
  <VFold title="현재 구매 불가 상품" class="products-wrapper">
    <section v-for="(product, index) in products" :key="product.getId()">
      <CartProduct
        v-if="product.getType() <= ProductType.SINGLE"
        :product="product"
        :onDelete="onDelete"
        :onMoveDetail="onMoveDetail"
      />
      <CartSetManyMealsProduct
        v-else
        :index="index"
        :product="product"
        :onDelete="onDelete"
        :onMoveDetail="onMoveDetail"
      />
    </section>
  </VFold>
</template>

<script>
import VFold from '@/presentationals/v2/components/layouts/molecules/VFold'

import CartProduct from '@/presentationals/v2/components/layouts/organisms/CartProduct'
import CartSetManyMealsProduct from '@/presentationals/v2/components/layouts/organisms/CartSetManyMealsProduct'

import { ProductType } from '@/models/Product/Product'

export default {
  name: 'CartUnpurchasableProducts',
  props: {
    products: {
      type: Array,
      required: true
    },
    onDelete: {
      type: Function,
      required: true
    },
    onMoveDetail: {
      type: Function,
      required: true
    }
  },
  components: {
    VFold,
    CartProduct,
    CartSetManyMealsProduct
  },
  data() {
    return {
      ProductType
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.products-wrapper {
  padding-bottom: 10px;
  background-color: $white;
}
</style>